export default __webpack_public_path__ + "static/harvestart-aec572cf64bc9a4c6f3c104655955fdc.jpg";